'use client';

import { isDev } from '@core/utils';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { useState } from 'react';

import { MONTHLY_DATES } from '@/app/donation/event/kb-check-card/_components/constants';
import { ENV } from '@/constants';
import { useDebugStore } from '@/stores/DebugStore';

const isDevDomain = ENV.NEXT_PUBLIC_API_DOMAIN?.includes('dev');

const KbEventDebugSection = () => {
  const { kbEventDateIndex, setKbEventDateIndex } = useDebugStore();

  return (
    <div className="flex flex-col gap-4">
      <span className="typo-body5 font-500 text-Gray-400">KB 이벤트</span>
      <div className="flex gap-4">
        {MONTHLY_DATES.map((d, i) => (
          <button
            key={i}
            type="button"
            className={`typo-body5 rounded-xsmall px-8 py-4 font-400 ${
              kbEventDateIndex === i
                ? 'bg-[#00c4ff] text-Gray-white'
                : 'bg-Gray-700 text-Gray-300'
            }`}
            onClick={() => setKbEventDateIndex(i)}
          >
            {d.range[0].slice(5, 7)}월
          </button>
        ))}
        <button
          type="button"
          className={`typo-body5 rounded-xsmall px-8 py-4 font-400 ${
            kbEventDateIndex === null
              ? 'bg-[#00c4ff] text-Gray-white'
              : 'bg-Gray-700 text-Gray-300'
          }`}
          onClick={() => setKbEventDateIndex(null)}
        >
          자동
        </button>
      </div>
    </div>
  );
};

/**
 * 페이지별 디버그 섹션 배열
 * - 새 페이지 디버그 항목 추가 시 여기에 추가
 */
const PAGE_DEBUG_SECTIONS: {
  pathMatch: string;
  component: () => ReactNode;
}[] = [{ pathMatch: 'kb-check-card', component: KbEventDebugSection }];

export const DonationDebugPanel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { skipReservation, toggleSkipReservation } = useDebugStore();
  const pathname = usePathname();

  if (!isDev && !isDevDomain) return null;

  const activeSections = PAGE_DEBUG_SECTIONS.filter((s) =>
    pathname.includes(s.pathMatch),
  );

  return (
    <div className="fixed bottom-20 right-20 z-[9999]">
      {isOpen ? (
        <div className="rounded-xsmall bg-Gray-900/90 p-12 text-Gray-white shadow-lg">
          <div className="mb-8 flex items-center justify-between gap-12">
            <span className="typo-body5 font-500">Debug</span>
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="typo-body5 font-400 text-Gray-400"
            >
              X
            </button>
          </div>
          <div className="flex flex-col gap-8">
            <label className="flex cursor-pointer items-center gap-8">
              <input
                type="checkbox"
                checked={skipReservation}
                onChange={toggleSkipReservation}
                className="size-16 accent-B-300"
              />
              <span className="typo-body5 font-400">사전예약 무시</span>
            </label>
            {activeSections.map((s) => (
              <s.component key={s.pathMatch} />
            ))}
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className="flex size-40 items-center justify-center rounded-pill bg-Gray-900/80 text-Gray-white shadow-lg"
        >
          D
        </button>
      )}
    </div>
  );
};
